import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
const StyledBox = styled(Box) `
    display: flex;
    padding: 0;
    background-color: ${grey[900]};
    border-radius: 4px;
    opacity: 0.95;
    align-items: center;
    gap: 8px;
`;
export const ActionBar = (props) => _jsx(StyledBox, Object.assign({}, props));
